import { useState, useLayoutEffect, RefObject } from 'react'

import useResizeObserver from '@react-hook/resize-observer'

export const useSize = (target: RefObject<HTMLElement>) => {
  const [size, setSize] = useState<DOMRect>()

  useLayoutEffect(() => {
    if (target.current !== null) {
      setSize(target.current.getBoundingClientRect())
    }
  }, [target])

  useResizeObserver(target, (entry) => setSize(entry.contentRect))

  return size
}
